module.exports = __webpack_public_path__ + "img/cvform.68821489.webp";